module.exports = __webpack_public_path__ + "static/media/HONOR.79989953.png";